import { PartialBrief } from '../../../Types/Brief'
import isRecommendationCity from './isRecommendationCity'
import qualifiesForConcierge from './qualifiesForConcierge'

export type RecommendationsTiming = 'before-submission' | 'after-submission' | 'none'

// `leadFeedCity` is nullable as well as optional, so guard on the type, not on `!== undefined`.
export const isLeadFeedCity = ({ leadFeedCity }: PartialBrief): boolean =>
  typeof leadFeedCity === 'string'

// Read by the sequence, the summary and the success page - they must not each derive their own.
const getRecommendationsTiming = (brief: PartialBrief): RecommendationsTiming => {
  if (qualifiesForConcierge(brief)) return 'none'
  if (!isLeadFeedCity(brief) || isRecommendationCity(brief)) return 'before-submission'

  return 'after-submission'
}

export default getRecommendationsTiming
